export default __webpack_public_path__ + "static/media/web-allina-icon-02.49061c45.svg";